import React, { type ComponentProps } from 'react';
import { StyleSheet } from 'react-native';
import { LoadingPlaceholder, theme } from '@sg/garnish';

/**
 * Components for the account skeleton loading states.
 */

export const SkeletonLoadingHeaderXS = (props: SkeletonLoadingProps) => {
  return (
    <LoadingPlaceholder
      style={styles.headerSpacingXS}
      rowHeight={baseHeight}
      palette="quinoa"
      {...props}
    />
  );
};

export const SkeletonLoadingContentSM = (props: SkeletonLoadingProps) => {
  return (
    <LoadingPlaceholder
      style={styles.contentSpacingSM}
      rowHeight={contentHeightSM}
      palette="quinoa"
      {...props}
    />
  );
};

export const SkeletonLoadingContentLG = (props: SkeletonLoadingProps) => {
  return (
    <LoadingPlaceholder
      style={styles.contentSpacingSM}
      rowHeight={contentHeightLG}
      palette="quinoa"
      {...props}
    />
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const baseHeight = 32;
const contentHeightSM = baseHeight * 2;
const contentHeightLG = baseHeight * 4;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  headerSpacingXS: {
    marginVertical: theme.spacing['2'],
  },
  contentSpacingSM: {
    marginBottom: theme.spacing['2'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type SkeletonLoadingProps = ComponentProps<typeof LoadingPlaceholder>;
